export default class ImageRatio {

    static blockContentImages() {
        const $ = jQuery;

        this.setImageSite($('.bs-block-content img:not(.original-size)'), 57);
    }

    /**
     * @param {jQuery} $image
     * @param {number} heightPercentage
     * @private
     */
    static setImageSite($image, heightPercentage) {
        const $ = jQuery;
        const width = $image.width();
        const height = width * (heightPercentage / 100);

        $image.height(height + 'px');
    }
}